<script lang="ts">
  import Button, { Label } from '@smui/button';
  import Input from '@smui/textfield';
  import { createEventDispatcher } from 'svelte';

  export let disableAdd = false;
  export let id: string;
  const dispatch = createEventDispatcher();

  let tempText = '';
  let tempImage = null;
  let tempFile = null;
  let newImage = [];
  let isTextEntered = false;
  let showFileError = false;
  let fileErrorMessage = '';

  function handleTextChange(event) {
    tempText = event.target.value;
    isTextEntered = tempText.trim().length > 0;
  }

function selectImage() {
    const uploaderInput = document.getElementById(`temp-uploader-input-${id}`);
    newImage = Array.from((uploaderInput as HTMLInputElement).files);
    (uploaderInput as HTMLInputElement).value = '';
    if (newImage.length > 0) {
      if (newImage[0].size > 2 * 1024 * 1024) {
        showFileError = true;
        fileErrorMessage = 'La dimensione del file non può superare 2MB';
        tempImage = null;
        tempFile = null;
      } else {
        showFileError = false;
        const reader = new FileReader();
        reader.onload = (e) => {
          tempImage = e.target.result;
          tempFile = newImage[0];
        };
        reader.readAsDataURL(newImage[0]);
      }
    }
  }

  function uploadImage() {
    document.getElementById(`temp-uploader-input-${id}`).click();
  }

  function addNewBox() {
    if (isTextEntered && !disableAdd) {
      dispatch('addBox', { text: tempText, image: tempImage, file: tempFile });
      tempText = '';
      tempImage = null;
      tempFile = null;
      isTextEntered = false;
    }
  }
</script>

{#if disableAdd}
  <p class="p-1 text-red-500">È possibile aggiungere solo un massimo di 5 box.</p>
{/if}
<div class="lg:grid-cols-2 md:gap-1 lg:gap-4 xl:gap-4 max-h-96 grid items-center grid-cols-1 gap-4 p-2 border border-black">
  <Input
    textarea
    input$placeholder="Testo"
    required
    bind:value={tempText}
    on:input={handleTextChange}
    class="min-w-48 max-h-72 w-full"
  />
  <div class="xl:flex-row lg:space-y-0 lg:space-x-4 flex flex-col items-center space-y-4">
    <Button on:click="{uploadImage}" type="button" variant="raised" class="lg:mb-0 w-full mb-2">
      <Label class="text-sm">Seleziona Immagine</Label>
    </Button>
    <div class="flex-1">
      {#if showFileError}
        <p class="p-1 text-xs text-red-500">{fileErrorMessage}</p>
      {/if}
      {#if tempImage}
        <img src={tempImage} alt="Selezionata" class="min-w-24 min-h-24 max-w-48 max-h-48 object-contain mt-2" />
      {:else}
        <span class="mt-2 text-xs text-gray-500">Nessun file selezionato</span>
      {/if}
    </div>
  </div>
  <input required hidden type="file" accept="image/*" id="temp-uploader-input-{id}" on:change="{selectImage}" />
  <div></div>
  <div class="justify-self-end pt-2">
    <Button on:click={addNewBox} type="button" variant="raised" class="lg:w-40" disabled={!isTextEntered || disableAdd}>
      <Label class="text-sm">Aggiungi</Label>
    </Button>
  </div>
</div>
